import { StatsSourceComponents } from './stats/externals';

export { StatsSourceComponents };

export const EventTypes = Object.freeze({
  CLICK: 'CLICK',
});

export const EventNames = Object.freeze({
  CLICKED_SIGN_UP: 'CLICKED_SIGN_UP',
  CLICKED_UPGRADE_CTA: 'CLICKED_UPGRADE_CTA',
  CLICKED_UPGRADE_DISCOUNT_PLAN_LINK: 'CLICKED_UPGRADE_DISCOUNT_PLAN_LINK',
  CLICKED_VIEW_PLANS: 'CLICKED_VIEW_PLANS',
  CLICKED_APP_STORE_LINK: 'CLICKED_APP_STORE_LINK',
});

export const ActionTypes = Object.freeze({
  // Stats
  ADD_EVENT: 'ADD_EVENT',
  LOG_EVENT: 'LOG_EVENT',
  INCREMENT_SEARCH_SEQUENCE: 'INCREMENT_SEARCH_SEQUENCE',
  RESET_SEARCH_SEQUENCE: 'RESET_SEARCH_SEQUENCE',
  GENERATE_BROWSE_SESSION_ID: 'GENERATE_BROWSE_SESSION_ID',
  SEND_EVENTS_TO_SERVER: 'SEND_EVENTS_TO_SERVER',
  CLEAR_STATS: 'CLEAR_STATS',
  CLEAR_STATS_EVENTS: 'CLEAR_STATS_EVENTS',
  UPDATE_LIVE_TRACKING: 'UPDATE_LIVE_TRACKING',
  CLEAR_LIVE_TRACKING: 'CLEAR_LIVE_TRACKING',
  INITIALIZE_STATS: 'INITIALIZE_STATS',
  LOG_CONCERT_NOTIFICATION_SENT: 'LOG_CONCERT_NOTIFICATION_SENT',
  LOG_CONCERT_NOTIFICATION_CLICKED: 'LOG_CONCERT_NOTIFICATION_CLICKED',
  LOG_CONCERT_NOTIFICATION_VIEWED: 'LOG_CONCERT_NOTIFICATION_VIEWED',
  LOG_PLAYBACK_INTERACTIONS: 'LOG_PLAYBACK_INTERACTIONS',
  LOG_CONCERT_NOTIFICATION_NO_LONGER_ON_PAGE: 'LOG_CONCERT_NOTIFICATION_NO_LONGER_ON_PAGE',
  LOG_AD_BLOCKER_AUDIO_MESSAGE_COACHMARK: 'LOG_AD_BLOCKER_AUDIO_MESSAGE_COACHMARK',
  LOG_AD_BLOCKER_HAMMER_COACHMARK: 'LOG_AD_BLOCKER_HAMMER_COACHMARK',
  LOG_WEB_VIEW_MODE_EVENT: 'LOG_WEB_VIEW_MODE_EVENT',
  LOG_BACKSTAGE_EVENT: 'LOG_BACKSTAGE_EVENT',
  ADD_VARIETY: 'ADD_VARIETY',
  DELETE_STATION: 'DELETE_STATION',
  SHUFFLE_EDIT: 'SHUFFLE_EDIT',
  AUDIO_TRACK_PLAYBACK_STATS: 'AUDIO_TRACK_PLAYBACK_STATS',
  LOG_SKIP_LIMIT_STATS: 'STATS_LOG_SKIP_LIMIT',
  LOG_TRACK_END: 'STATS_LOG_TRACK_END',
  LOG_TRACK_END_STATION: 'LOG_TRACK_END_STATION',
  LOG_FPS_DATA: 'STATS_LOG_FPS_DATA',
  LOG_BROWSER_AUTOPLAY_PLAYBACK: 'STATS_LOG_BROWSER_AUTOPLAY_PLAYBACK',
  EXPIRE_VALUE_EXCHANGE_REWARD: 'EXPIRE_VALUE_EXCHANGE_REWARD',
  ADD_COLLECTION_ITEM: 'ADD_COLLECTION_ITEM',
  LOG_REPLAY_TRACK: 'LOG_REPLAY_TRACK',
  USER_LOGGED_IN_ATT_PREMIUM: 'USER_LOGGED_IN_ATT_PREMIUM',
  LOG_AB_EXPERIMENT_DIVERSION_POINT: 'LOG_AB_EXPERIMENT_DIVERSION_POINT',
  LOG_WEB_PA_AB_EXPERIMENT_EXPOSURE: 'LOG_WEB_PA_AB_EXPERIMENT_EXPOSURE',
  LOG_VOICE_TRACK_METRIC: 'LOG_VOICE_TRACK_METRIC',
  LOG_RECENTLY_PLAYED_CAROUSEL_EVENT: 'LOG_RECENTLY_PLAYED_CAROUSEL_EVENT',

  STATION_STARTED: 'station_started',
  STATION_CREATED: 'station_created',

  ENTER_REDEEM_FLOW_FOR_URL: 'enter_redeem_flow_for_url',

  LIVE_END: 'end',

  LOG_PREMIUM_PLAYLIST_UNLOCKED: 'log_premium_playlist_unlocked',
  LOG_PREMIUM_PLAYLIST_COACHMARK: 'log_premium_playlist_coachmark',

  WEB_DISPLAY_AD_LIFECYCLE: 'web_display_ad_lifecycle',
  WEB_DISPLAY_AD_REQUEST: 'web_display_ad_request',
  WEB_DISPLAY_AD_RESPONSE: 'web_display_ad_response',
  WEB_DISPLAY_AD_ERROR_RESPONSE: 'web_display_ad_error_response',
  WEB_DISPLAY_AD_IAS_PET_REQUEST: 'web_display_ad_ias_pet_request',
  WEB_DISPLAY_AD_IAS_PET_RESPONSE: 'web_display_ad_ias_pet_response',
  WEB_DISPLAY_AD_START_RENDER: 'web_display_ad_start_render',
  WEB_DISPLAY_AD_FINISH_RENDER: 'web_display_ad_finish_render',
  WEB_DISPLAY_AD_DISMISSED: 'web_display_ad_dismissed',
  WEB_DISPLAY_AD_IAS_GPT_SCRIPT_LOAD_FAIL: 'web_display_ad_ias_gpt_script_load_fail',
  WEB_DISPLAY_AD_IAS_PET_SCRIPT_LOAD_FAIL: 'web_display_ad_ias_pet_script_load_fail',
});

export const UserMessages = Object.freeze({
  GENERIC_SUBSCRIPTION_FAILURE: 'GENERIC_SUBSCRIPTION_FAILURE',
  INVALID_PANDORA_ID: 'INVALID_PANDORA_ID',
  ALREADY_VERIFIED: 'ALREADY_VERIFIED',
  INVALID_AGE: 'INVALID_AGE',
  PARTNER_UPGRADE: 'PARTNER_UPGRADE',
  API_UNEXPECTED_ERROR: 'API_UNEXPECTED_ERROR',
  FETCH_PLAYLIST: 'FETCH_PLAYLIST',
  GENERAL_SERVER_ERROR: 'GENERAL_SERVER_ERROR',
  ACQUIRE_PRODUCT_FAILED: 'ACQUIRE_PRODUCT_FAILED',
  GENERIC_COMPONENT_ERROR: 'GENERIC_COMPONENT_ERROR',
  INELIGIBLE_PARTNER_UPGRADE: 'INELIGIBLE_PARTNER_UPGRADE',
  FP_AGE_REQUIREMENT: 'FP_AGE_REQUIREMENT',
  FP_INELIGIBLE_API_ERROR: 'FP_INELIGIBLE_API_ERROR',
  INVALID_CODE: 'INVALID_CODE',
  ALREADY_SUBSCRIBED: 'ALREADY_SUBSCRIBED',
  PLAYBACK_FAILURE: 'PLAYBACK_FAILURE',
  START_STATION_ERROR: 'START_STATION_ERROR',
  LISTENER_NOT_AUTHORIZED: 'LISTENER_NOT_AUTHORIZED',
  BANDWIDTH_INSUFFICIENT: 'BANDWIDTH_INSUFFICIENT',
});
